export function getSeedtagContext(isDesktop: boolean): object {
	const desktopSlots = {
		'incontent-ad': {
			sizes: [[728, 90]],
			publisherId: '4606-5508-01',
			adUnitId: '29833673',
			placement: 'inBanner',
		},
		'incontent-ad-inc': {
			sizes: [[728, 90]],
			publisherId: '4606-5508-01',
			adUnitId: '29833673',
			placement: 'inBanner',
		},
		'incontent-ad-plus-billboard-bottom': {
			sizes: [
				[728, 90],
				[970, 250],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833679',
			placement: 'inBanner',
		},
		leader_bottom: {
			sizes: [[728, 90]],
			publisherId: '4606-5508-01',
			adUnitId: '29833801',
			placement: 'inBanner',
		},
		leader_middle: {
			sizes: [[728, 90]],
			publisherId: '4606-5508-01',
			adUnitId: '29833615',
			placement: 'inBanner',
		},
		leader_plus_top: {
			sizes: [
				[728, 90],
				[970, 250],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833673',
			placement: 'inBanner',
		},
		leader_top: {
			sizes: [[728, 90]],
			publisherId: '4606-5508-01',
			adUnitId: '29833673',
			placement: 'inBanner',
		},
		'leader-ad-plus-middle': {
			sizes: [
				[728, 90],
				[970, 250],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833615',
			placement: 'inBanner',
		},
		'leader-ad-plus-top': {
			sizes: [
				[728, 90],
				[970, 250],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833673',
			placement: 'inBanner',
		},
		'leader-bottom-inc': {
			sizes: [[728, 90]],
			publisherId: '4606-5508-01',
			adUnitId: '29833801',
			placement: 'inBanner',
		},
		'leader-plus-inc': {
			sizes: [
				[728, 90],
				[970, 250],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833673',
			placement: 'inBanner',
		},
		mpu_bottom: {
			sizes: [[300, 250]],
			publisherId: '4606-5508-01',
			adUnitId: '29833629',
			placement: 'inArticle',
		},
		mpu_middle: {
			sizes: [[300, 250]],
			publisherId: '4606-5508-01',
			adUnitId: '29833623',
			placement: 'inArticle',
		},
		mpu_plus_top: {
			sizes: [
				[300, 250],
				[300, 600],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833644',
			placement: 'inArticle',
		},
		mpu_top: {
			sizes: [[300, 250]],
			publisherId: '4606-5508-01',
			adUnitId: '29833644',
			placement: 'inArticle',
		},
		'mpu-bottom-inc': {
			sizes: [[300, 250]],
			publisherId: '4606-5508-01',
			adUnitId: '29833629',
			placement: 'inArticle',
		},
		'mpu-top-inc': {
			sizes: [[300, 250]],
			publisherId: '4606-5508-01',
			adUnitId: '29833644',
			placement: 'inArticle',
		},
		'native-mpu': {
			sizes: [[300, 250]],
			publisherId: '4606-5508-01',
			adUnitId: '29833658',
			placement: 'inArticle',
		},
		'native-ad-plus-leader': {
			sizes: [
				[728, 90],
				[970, 250],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833673',
			placement: 'inBanner',
		},
		overlay_leader_top: {
			sizes: [[728, 90]],
			publisherId: '4606-5508-01',
			adUnitId: '29833673',
			placement: 'inBanner',
		},
		overlay_mpu_top: {
			sizes: [[300, 250]],
			publisherId: '4606-5508-01',
			adUnitId: '29833644',
			placement: 'inArticle',
		},
		'sky-leader-plus-top': {
			sizes: [
				[728, 90],
				[970, 250],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833673',
			placement: 'inBanner',
		},
	};

	const mobileSlots = {
		'incontent-ad-plus-inc': {
			sizes: [[728, 90]],
			publisherId: '4606-5508-01',
			adUnitId: '29833673',
			placement: 'inBanner',
		},
		'incontent-all-top': {
			sizes: [
				[728, 90],
				[970, 250],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833686',
			placement: 'inBanner',
		},
		'incontent-mobile-flex': {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833623',
			placement: 'inArticle',
		},
		'incontent-narrow-all-top': {
			sizes: [[728, 90]],
			publisherId: '4606-5508-01',
			adUnitId: '29833673',
			placement: 'inBanner',
		},
		'mobile-autoplay-plus': {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29956717',
			placement: 'inStream',
		},
		'mobile-banner': {
			sizes: [[320, 50]],
			publisherId: '4606-5508-01',
			adUnitId: '29833829',
			placement: 'inBanner',
		},
		'mobile-banner-bottom': {
			sizes: [[320, 50]],
			publisherId: '4606-5508-01',
			adUnitId: '29833801',
			placement: 'inBanner',
		},
		'mobile-banner-plus': {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833829',
			placement: 'inBanner',
		},
		'mobile-flex-bottom': {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833801',
			placement: 'inBanner',
		},
		'mobile-flex-inc': {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833829',
			placement: 'inBanner',
		},
		'mobile-highimpact-plus': {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833644',
			placement: 'inArticle',
		},
		'mobile-incontent-ad': {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833658',
			placement: 'inArticle',
		},
		'mobile-incontent-ad-inc': {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833658',
			placement: 'inArticle',
		},
		'mobile-incontent-ad-plus-inc': {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833658',
			placement: 'inArticle',
		},
		'mobile-incontent-all': {
			sizes: [[300, 250]],
			publisherId: '4606-5508-01',
			adUnitId: '29833658',
			placement: 'inArticle',
		},
		'mobile-incontent-plus': {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833658',
			placement: 'inArticle',
		},
		'mobile-incontent-plus-bottom': {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '4606-5508-01',
			adUnitId: '29833629',
			placement: 'inArticle',
		},
		'mobile-mpu': {
			sizes: [[300, 250]],
			publisherId: '4606-5508-01',
			adUnitId: '29833658',
			placement: 'inArticle',
		},
		'mobile-mpu-bottom': {
			sizes: [[300, 250]],
			publisherId: '4606-5508-01',
			adUnitId: '29833629',
			placement: 'inArticle',
		},
		'mobile-native': {
			sizes: [[300, 250]],
			publisherId: '4606-5508-01',
			adUnitId: '29833596',
			placement: 'inArticle',
		},
		'mobile-native-plus-top': {
			sizes: [[300, 250]],
			publisherId: '4606-5508-01',
			adUnitId: '29833596',
			placement: 'inArticle',
		},
		'mobile-nav-ad-plus-banner': {
			sizes: [[320, 50]],
			publisherId: '4606-5508-01',
			adUnitId: '29833596',
			placement: 'inArticle',
		},
	};

	return {
		enabled: false,
		slots: isDesktop ? desktopSlots : mobileSlots,
	};
}
